import { RouteObject } from "react-router-dom";
import { FeatureFlags } from "@/core/config/featureFlags";
import { MainLayout } from "@/layouts/MainLayout";
import { AuthLayout } from "@/layouts/AuthLayout";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import { LoginPage } from "@modules/auth/features/login/presentation/LoginPage";
import { RegisterPage } from "@modules/auth/features/register/presentation/RegisterPage";
import { ForgotPasswordPage } from "@modules/auth/features/forgotPassword/presentation/ForgotPasswordPage";
import { NotFound } from "@modules/errors/presentation/NotFound";
import { Unauthorized } from "@/modules/errors/presentation/Unauthorized";
import { ProtectedRoute } from "./ProtectedRoute";
import { LimitConfigPage } from '@/pages/limit-control/LimitConfigPage';
import { OrdersPage } from '@/pages/orders/OrdersPage';
import { FutureFlowsPage } from '@/pages/dashboard/FutureFlowsPage';
import { SensitivityMeasuresPage } from "@/pages/dashboard/SensitivityMeasuresPage";
import { DashboardGraphicsPage } from "@/pages/dashboard/DashboardGraphicsPage";
import { HomePage } from "@/pages/dashboard/HomePage";
import { InstrumentsPage } from "@/pages/instruments/InstrumentsPage";
import { VariableOrdersPage } from "@/pages/orders/VariableOrdersPage";
import { OrdersListPage } from "@/pages/orders/OrdersListPage";
import { ClientOrdersPage } from "@/pages/orders/ClientOrdersPage";

// Aquí importar nuevos componentes

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={<DashboardLayout />}
            flag={FeatureFlags.DASHBOARD}
          />
        ),
        children: [
          {
            index: true,
            path: '',
            element: <HomePage />,
          },
          {
            path: "",
            element: (
              <ProtectedRoute
                element={<HomePage />}
                flag={FeatureFlags.DASHBOARD}
              />
            ),
          },
          {
            path: 'dashboard',
            children: [
              {
                path: "graphics",
                element: (
                  <ProtectedRoute
                    element={<DashboardGraphicsPage />}
                    flag={FeatureFlags.DASHBOARD_FUTURE_FLOWS}
                  />
                ),
              },
              {
                path: "future-flows",
                element: (
                  <ProtectedRoute
                    element={<FutureFlowsPage />}
                    flag={FeatureFlags.DASHBOARD_FUTURE_FLOWS}
                  />
                ),
              },
              {
                path: "sensitivity-measures",
                element: (
                  <ProtectedRoute
                    element={<SensitivityMeasuresPage />}
                    flag={FeatureFlags.DASHBOARD_FUTURE_FLOWS}
                  />
                ),
              },
            ],
          },
          {
            path: 'orders',
            children: [
              {
                path: "fixed-income",
                element: (
                  <ProtectedRoute
                    element={<OrdersPage />}
                    flag={FeatureFlags.ORDERS_FIXED_INCOME}
                  />
                ),
              },
              {
                path: "variable-income",
                element: (
                  <ProtectedRoute
                    element={<VariableOrdersPage />}
                    flag={FeatureFlags.ORDERS_VARIABLE_INCOME}
                  />
                ),
              },
              {
                path: "instruments",
                element: (
                  <ProtectedRoute
                    element={<InstrumentsPage />}
                    flag={FeatureFlags.ORDERS_INSTRUMENTS}
                  />
                ),
              },
              {
                path: "list",
                element: (
                  <ProtectedRoute
                    element={<OrdersListPage />}
                    flag={FeatureFlags.ORDERS_LIST}
                  />
                ),
              },
              {
                path: "client-orders",
                element: (
                  <ProtectedRoute
                    element={<ClientOrdersPage />}
                    flag={FeatureFlags.ORDERS_MODULE}
                  />
                ),
              },
            ],
          },
          {
            path: "limit-control",
            children: [
              {
                path: "limit-config",
                element: (
                  <ProtectedRoute
                    element={<LimitConfigPage />}
                    flag={FeatureFlags.LIMIT_CONFIG_MODULE}
                  />
                ),
              },
              {
                path: "limit-evaluation",
                element: (
                  <ProtectedRoute
                    element={<LimitConfigPage />}
                    flag={FeatureFlags.LIMIT_EVALUATION_MODULE}
                  />
                ),
              },
            ],
          },

          // Aquí agregar nuevas rutas
        ],
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
    ],
  },
  {
    path: "unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
